<h2 class="mb-2">We'll automatically schedule a cleaning 1 hour after every checkout from {{ property().name }}</h2>

<div class="text-text-secondary mb-4 leading-relaxed">
  This gives your current guest time to leave, while still getting your property guest-ready in case of a same-day
  check-in.
</div>

<div class="flex items-center gap-3 mt-6 border border-border-secondary rounded-lg p-4">
  <img
    [src]="property().picture"
    [alt]="property().name + ' property image'"
    class="h-8 w-8 rounded object-cover flex-shrink-0"
    onerror="this.style.display='none'" />

  <div>{{ formattedAddress() }}</div>
</div>
